import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AccountsMenu from "./AccountsMenu";
import { NavLink, Link } from "react-router-dom";
import YearsDropDown from "../Shared/YearsDropDown";
import Pagination from "../General/Pagination";

function OpeningBalances() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [DefaultFYear, setDefaultFYear] = useState(
    localStorage.getItem("DefaultFYear")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const [AccountNo, setAccountNo] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [showZeroAccounts, setShowZeroAccounts] = useState(false);

  const [appliedAccountNo, setAppliedAccountNo] = useState("");
  const [appliedAccountName, setAppliedAccountName] = useState("");
  const [appliedShowZeroAccounts, setAppliedShowZeroAccounts] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const fmtAmt = (v) =>
    Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

  document.title = "Opening Balances";

  const runSearch = () => {
    setAppliedAccountNo(AccountNo.trim());
    setAppliedAccountName(AccountName.trim());
    setAppliedShowZeroAccounts(showZeroAccounts);
    setPageNo(1);
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (!DefaultFYear) {
      setLedger([]);
      setTotalRecords(0);
      setTotalDebit(0);
      setTotalCredit(0);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Accounts/GetOpeningBalancesByYear",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo,
        pageSize,
        FYear: parseInt(DefaultFYear, 10) || 0,
        AccountNo: appliedAccountNo,
        Keywords: appliedAccountName,
        ShowZeroAccounts: appliedShowZeroAccounts,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setTotalDebit(response.data.TotalDebit ?? 0);
          setTotalCredit(response.data.TotalCredit ?? 0);
        } else {
          setLedger([]);
          setTotalRecords(0);
          setTotalDebit(0);
          setTotalCredit(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setTotalRecords(0);
        setTotalDebit(0);
        setTotalCredit(0);
        setLoading(false);
      });
  }, [
    pageNo,
    pageSize,
    DefaultFYear,
    searchTrigger,
    appliedAccountNo,
    appliedAccountName,
    appliedShowZeroAccounts,
    AccessKey,
    UserID,
    MemberType,
  ]);

  const printUrl = `/Accounts/PrintOpeningBalance?DefaultYear=${encodeURIComponent(
    DefaultFYear || ""
  )}&AccountNo=${encodeURIComponent(appliedAccountNo)}&Keywords=${encodeURIComponent(
    appliedAccountName
  )}&ShowZeroAccounts=${appliedShowZeroAccounts ? "1" : "0"}`;

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{count++ + pageSize * (pageNo - 1)}</td>
          <td>{item.ID}</td>
          <td>
            <NavLink
              to={`/Accounts/GeneralLedger/${item.Selected_Account.Account_code}?FYear=${DefaultFYear || ""}`}
            >
              {item.Selected_Account.Account_code}
            </NavLink>
          </td>
          <td>{item.Selected_Account.Account_desc}</td>
          <td className="text-end">{fmtAmt(item.DR_Amt)}</td>
          <td className="text-end">{fmtAmt(item.CR_Amt)}</td>
          <td>
            <ul className="inline-action">
              <li>
                <NavLink
                  to={`/Accounts/EditOpeningBalance/${item.AccountID}?FYear=${DefaultFYear || ""}`}
                  className="green"
                >
                  <i className="ri-edit-line"></i>
                </NavLink>
              </li>
              <li>
                <a className="red">
                  <i className="ri-delete-bin-line"></i>
                </a>
              </li>
            </ul>
          </td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <AccountsMenu />

      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Opening Balances
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Opening Balances</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/Accounts/AddOpBalance"
                    className="button button-white button-icon"
                  >
                    Add Opening Balance
                    <i className="ri-add-line"></i>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body p-md-4">
                <div className="row gy-3 align-items-end">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Year:</label>
                      <select
                        className="form-select"
                        required
                        name="ddlYears"
                        value={DefaultFYear || ""}
                        onChange={(e) => {
                          setDefaultFYear(e.target.value);
                          setPageNo(1);
                          setSearchTrigger((prev) => prev + 1);
                        }}
                      >
                        <option value="">Please Select</option>
                        <YearsDropDown selected={DefaultFYear} />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Account No:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={AccountNo}
                        onChange={(e) => setAccountNo(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            runSearch();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Account Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={AccountName}
                        onChange={(e) => setAccountName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            runSearch();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="showZeroOpeningBalances"
                        checked={showZeroAccounts}
                        onChange={(e) => setShowZeroAccounts(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="showZeroOpeningBalances"
                      >
                        Show zero-balance accounts
                      </label>
                    </div>
                    <p className="text-muted small mb-0">
                      When unchecked, accounts with debit and credit both 0 are hidden.
                    </p>
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      className="button button-primary w-100"
                      onClick={runSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-3">
              <div className="card-body table_card">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th colSpan={4}>
                        {totalRecords} record{totalRecords === 1 ? "" : "s"} found
                      </th>
                      <th colSpan={3} className="text-end text-muted fw-normal">
                        Grand total (all matching rows)
                      </th>
                    </tr>
                    <tr>
                      <th>Sr#</th>
                      <th>ID</th>
                      <th>Code</th>
                      <th>Account</th>
                      <th className="text-end">Debit</th>
                      <th className="text-end">Credit</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="7">
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : (
                      renderLedger()
                    )}
                  </tbody>
                  {!loading && listOfLedger.length > 0 && (
                    <tfoot>
                      <tr>
                        <th colSpan={4} className="text-end">
                          Grand total
                        </th>
                        <th className="text-end">{fmtAmt(totalDebit)}</th>
                        <th className="text-end">{fmtAmt(totalCredit)}</th>
                        <th></th>
                      </tr>
                    </tfoot>
                  )}
                </table>

                {totalRecords > pageSize && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value, 10));
                            }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </div>
                      </div>
                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={setPageNo}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container">
            <div className="card mt-2">
              <div className="card-body p-md-4">
                <div className="row">
                  <div className="col-md-2 offset-md-10 text-end">
                    <Link
                      target="_blank"
                      to={printUrl}
                      className="w-100 button button-primary"
                    >
                      Print This List
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OpeningBalances;
